<template>
  <div class="rules-accept">
    <p class="mt-1">{{$t('components.Profile.taxDataWarn.title')}}</p>
  </div>
</template>

<script>

export default {

}
</script>
